"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function featureMatcher(requestedFeaturePolicy, featurePolicy) {
    try {
        if (!featurePolicy.startsWith('feature:')) {
            return false;
        }
        return requestedFeaturePolicy === featurePolicy;
    }
    catch ({ message }) {
        console.error('Error in policy evaluation', { requestedFeaturePolicy, featurePolicy, message });
        return false;
    }
}
exports.default = featureMatcher;
//# sourceMappingURL=featureMatcher.js.map